import { render } from "./HeaderPartSisa.vue?vue&type=template&id=2b6e5051&scoped=true"
import script from "./HeaderPartSisa.vue?vue&type=script&lang=js"
export * from "./HeaderPartSisa.vue?vue&type=script&lang=js"

import "./HeaderPartSisa.vue?vue&type=style&index=0&id=2b6e5051&lang=css"
import "./HeaderPartSisa.vue?vue&type=style&index=1&id=2b6e5051&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6e5051"]])

export default __exports__